// Recovered compiled webpack factory 52036. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { U: () => n, _: () => s });
  let n = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"],
    s = ["initial", ...n];
}
